import { render, staticRenderFns } from "./CallMailSupportButtons.vue?vue&type=template&id=8e61da24&scoped=true"
import script from "./CallMailSupportButtons.vue?vue&type=script&lang=js"
export * from "./CallMailSupportButtons.vue?vue&type=script&lang=js"
import style0 from "./CallMailSupportButtons.vue?vue&type=style&index=0&id=8e61da24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e61da24",
  null
  
)

export default component.exports